export default __webpack_public_path__ + "static/media/copy.7d5d1a8d.svg";